import React from 'react'
import {useStyles} from "./VideoCard.css";
import {Card, CardContent, CardMedia, Divider, LinearProgress} from "@mui/material";
import AssociationLogo from "../../../../commons/utils/logo/AssociationLogo";
import {AccessTime} from "@mui/icons-material";
import {useIntl} from "react-intl";

const VideoCard = ({video, headerSize, textSize}) => {
    const classes = useStyles({headerSize: headerSize, textSize: textSize})

    // Internationalization for simple strings
    const intl = useIntl();

    return (
        <Card className={classes.videoCard}>
            <CardMedia>
                {
                    !video.vimeo.transcoded
                        ? <div className={classes.thumbnailTranscoding}>
                            <p>In preparation...</p>
                            <AccessTime/>
                            <LinearProgress/>
                        </div>
                        : <img src={video.vimeo.firstScoreThumbnails?.size200 || video.vimeo.thumbnails?.size200} height={120}
                               alt="Thumbnail of video"/>
                }
            </CardMedia>
            <CardContent className={classes.videoCardContent}>
                <div className={classes.row}>
                    <AssociationLogo association={video.basics.association} height={30} width={30}/>
                    <div className={classes.discipline}>
                        {intl.formatMessage({id: `app.ids.discipline.${video.basics.discipline}`})}
                        <span> - </span>
                        {intl.formatMessage({
                            id: `app.ids.ageGroup.${video.basics.ageGroup}`
                        })} ({intl.formatMessage({
                        id: `app.ids.gender.${video.basics.gender}`
                    })})
                    </div>
                </div>
                <Divider orientation={"horizontal"} style={{width: "100%"}}/>
                <div className={classes.description}>
                    <div>
                        <span>
                            {video.basics.tournament} ({video.basics.year})
                        </span>
                    </div>
                    <div>
                        <span>
                            <b>{video.basics.surnameAthlete1}</b> vs. <b>{video.basics.surnameAthlete2}</b> ({intl.formatMessage({
                            id: `app.ids.bout.${video.basics.bout}`
                        })})
                        </span>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export default VideoCard
